import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDatepickerMaskDirective } from '@anihis/shared/src/shared/directive/mat-datepicker-mask.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { TranslocoModule } from '@jsverse/transloco';
import { getMinAnimalBirthDate } from '@anihis/shared/src/validators/birth-date.validators';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'anihis-potvrda-sterilizacije',
  templateUrl: './potvrda-sterilizacije.component.html',
  styleUrls: ['./potvrda-sterilizacije.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatDatepickerMaskDirective,
    MatIconModule,
    MatNativeDateModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PotvrdaSterilizacijeComponent implements OnInit, OnDestroy {
  @Output() formChange = new EventEmitter<any>();

  form: FormGroup;
  private destroy$ = new Subject<void>();
  minDate = getMinAnimalBirthDate();
  today: Date = new Date();

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      dateOfSterilization: [undefined],
      protocolNumber: [''],
      note: [''],
      veterinarianName: [''],
    });
  }

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(debounceTime(250), takeUntil(this.destroy$))
      .subscribe(() => this.formChange.emit(this.form.getRawValue()));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get dateOfSterilization(): FormControl {
    return this.form.get('dateOfSterilization') as FormControl;
  }

  get protocolNumber(): FormControl {
    return this.form.get('protocolNumber') as FormControl;
  }

  get note(): FormControl {
    return this.form.get('note') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  clearForm() {
    this.form.reset({
      dateOfSterilization: undefined,
      protocolNumber: '',
      note: '',
      veterinarianName: '',
    });
  }
}
